import Vue from "vue";
import i18n from "@/plugins/vue-i18n";

// INPUT: time in miliseconds
// OUTPUT: human readable time period
Vue.filter("formatPeriod", (time, options = {}) => {

  if (time === 0) return i18n.tc("NOTIFICATIONS_SECS", 0);

  const { minimal = false, useJustNow = false } = options;
  if (useJustNow && time < 5000) return i18n.t("NOTIFICATIONS_JUST_NOW");

  let tempTime = Math.round(time / 1000);
  let secondsString = "";
  let minutesString = "";
  let hoursString = "";
  let daysString = "";

  let days = Math.floor(tempTime / 86400);
  tempTime = tempTime % 86400;

  let hours = Math.floor(tempTime / 3600);
  tempTime = tempTime % 3600;

  let minutes = Math.floor(tempTime / 60);
  let seconds = tempTime % 60;
  let finalString = "";

  if (days > 0) {
    daysString = i18n.tc("NOTIFICATIONS_DAYS", days);
    finalString += daysString + " ";
    if (minimal) return daysString;

    if (hours > 0) {
      finalString += i18n.tc("NOTIFICATIONS_HRS", hours);
    }
    return finalString.trim();
  } else if(hours > 0) {
    hoursString = i18n.tc("NOTIFICATIONS_HRS", hours);
    finalString += hoursString + " ";
    if (minimal) return hoursString;

    if (minutes > 0) {
      finalString += i18n.tc("NOTIFICATIONS_MINS", minutes);
    }
    return finalString.trim();
  } else if (minutes > 0) {
    minutesString = i18n.tc("NOTIFICATIONS_MINS", minutes);
    finalString += minutesString + " ";
    if (minimal) return minutesString;

    if (seconds > 0) {
      finalString += i18n.tc("NOTIFICATIONS_SECS", seconds);
    }
    return finalString.trim();
  } else if (seconds > 0) {
    secondsString = i18n.tc("NOTIFICATIONS_SECS", seconds);
    return secondsString;
  }else{
    return i18n.tc("NOTIFICATIONS_SECS", 0);
  }
});
